<style>


</style>

<template>
  <div style="width: 100%;">

    <DialogOnboarding v-if="$store.state.activeTemplate.showOnboardingDialog"/>

    <v-btn fab small style="position: fixed; right: 40px; bottom: 40px; z-index: 1" @click="scrollTop">
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>

    <div>
      <div>
        <TemplateNavigator/>
        <div v-if="$store.state.activeTemplate.isGenerating !== 'init'">
          <TemplatePreviewStatic v-if="this.$store.state.mode === 'static'"/>
          <TemplatePreviewModules v-if="this.$store.state.mode !== 'static'"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Mixin from '@/mixins/mixin';
import DialogOnboarding from '@/components/dialogs/DialogOnboarding.vue';
import TemplateNavigator from '@/pages/Template/TemplateNavigator';
import TemplatePreviewStatic from '@/pages/Template/TemplatePreviewStatic';
import TemplatePreviewModules from '@/pages/Template/TemplatePreviewModules';

export default {
  name: 'TemplatePreview.vue',
  components: {
    TemplatePreviewModules,
    TemplatePreviewStatic,
    TemplateNavigator,
    DialogOnboarding,
  },
  mixins: [Mixin],
  data: () => ({}),
  methods: {
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
